import React from 'react';

const PropertiesSection = () => {
  return (
    <section id="biens" className="bg-white rounded-xl shadow-sm border border-slate-200 p-3 md:p-6 scroll-mt-32 mt-6">
      <div className="flex items-center gap-3 mb-4">
        <div className="w-10 h-10 rounded-lg bg-blue-100 flex items-center justify-center">
          <i className="bi bi-houses-fill text-blue-600 text-lg"></i>
        </div>
        <div>
          <h2 className="text-xl font-bold text-slate-800">4. Biens présentés</h2>
          <p className="text-sm text-slate-500">Historique des propositions</p>
        </div>
      </div>

      <div className="text-center py-12 text-slate-400">
        <i className="bi bi-inbox text-5xl mb-3 block"></i>
        <p className="text-sm">Aucun bien présenté</p>
        <button 
          type="button"
          className="mt-4 px-5 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-lg font-semibold transition"
        >
          <i className="bi bi-plus-circle mr-2"></i>
          Ajouter un bien
        </button>
      </div>
    </section>
  );
};

export default PropertiesSection;